// [index.js]
// Wrapper module for treating bootstrap-vue-next as bootstrap-vue.
// Export all bootstrap-vue-next content.
// @see https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Statements/export#syntax
export * from "bootstrap-vue-next";
import { createBootstrap } from "bootstrap-vue-next";
// Compoernent
import {
  BAccordion,
  BAlert,
  BAvatar,
  BBadge,
  BBreadcrumb,
  BButton,
  BCard,
  BCarousel,
  BCollapse,
  BContainer,
  BDropdown,
  BForm,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormSelect,
  BFormSpinbutton,
  BFormTags,
  BFormTextarea,
  BImg,
  BInputGroup,
  BLink,
  BListGroup,
  BModal,
  BNav,
  BNavbar,
  BOffcanvas,
  BOverlay,
  BPagination,
  BPlaceholder,
  BPopover,
  BProgress,
  BSpinner,
  BTable,
  BTabs,
  BToast,
  BTooltip,
} from "bootstrap-vue-next";

// Add
import {
  BListGroupItem,
  BFormInvalidFeedback,
  BCol,
  BRow,
} from "bootstrap-vue-next";

export default class bootstrapvue {
  /**
   *
   * @param {*} app
   * @param {*} options
   */
  static install = (app) => {
    app.use(createBootstrap());

    // Compoernent
    app.component("BAccordion", BAccordion);
    app.component("BAlert", BAlert);
    app.component("BAvatar", BAvatar);
    app.component("BBadge", BBadge);
    app.component("BBreadcrumb", BBreadcrumb);
    app.component("BButton", BButton);
    app.component("BCard", BCard);
    app.component("BCarousel", BCarousel);
    app.component("BCollapse", BCollapse);
    app.component("BContainer", BContainer);
    app.component("BDropdown", BDropdown);
    app.component("BForm", BForm);
    app.component("BFormCheckbox", BFormCheckbox);
    app.component("BFormFile", BFormFile);
    app.component("BFormGroup", BFormGroup);
    app.component("BFormInput", BFormInput);
    app.component("BFormRadio", BFormRadio);
    app.component("BFormSelect", BFormSelect);
    app.component("BFormSpinbutton", BFormSpinbutton);
    app.component("BFormTags", BFormTags);
    app.component("BFormTextarea", BFormTextarea);
    app.component("BImg", BImg);
    app.component("BInputGroup", BInputGroup);
    app.component("BLink", BLink);
    app.component("BListGroup", BListGroup);
    app.component("BModal", BModal);
    app.component("BNav", BNav);
    app.component("BNavbar", BNavbar);
    app.component("BOffcanvas", BOffcanvas);
    app.component("BOverlay", BOverlay);
    app.component("BPagination", BPagination);
    app.component("BPlaceholder", BPlaceholder);
    app.component("BPopover", BPopover);
    app.component("BProgress", BProgress);
    app.component("BSpinner", BSpinner);
    app.component("BTable", BTable);
    app.component("BTabs", BTabs);
    app.component("BToast", BToast);
    app.component("BTooltip", BTooltip);

    // Add
    app.component("BListGroupItem", BListGroupItem);
    app.component("BFormInvalidFeedback", BFormInvalidFeedback);
    app.component("BCol", BCol);
    app.component("BRow", BRow);
  };
}
